import React from 'react'

import DataTable from '../components/DataTable'

const Personalisation = () => {
  return (
    <DataTable url='db_personalised' title="personalised" />
  )
}
export default Personalisation